<div class="relative w-full">
  <button
    (click)="toggleDropdown()"
    class="block w-full h-[64px] border border-border-default bg-transparent rounded-xl py-2 pl-3 pr-10 text-left text-base hover:bg-surface-subtle active:scale-[0.99] transition duration-150 ease-out-quart focus:outline-none focus-visible:ring-2 focus-visible:ring-border-focus sm:text-sm relative flex items-center justify-between">
    <div class="flex items-center gap-2">
      <div class="dark:bg-white">
        <img
          class="border-r-8"
          src="{{ businessesLogo }}"
          alt="Right Logo"
          class="w-8 h-8" />
      </div>

      <div class="flex flex-col">
        <span class="truncate text-text font-bold leading-none">
          {{ businessesName }}
        </span>

        <span class="text-supporting-text text-sm font-normal leading-4">
          {{ selectedLocation.name }}
        </span>
      </div>
    </div>
    <div class="flex items-center space-x-3">
      <span
        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
        <svg
          class="h-5 w-5 text-icon-secondary transition-transform duration-200 ease-out-quart"
          [class.rotate-180]="dropdownOpen"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7" />
        </svg>
      </span>
    </div>
  </button>
  <div
    *ngIf="dropdownOpen"
    class="absolute mt-1 w-full rounded-xl shadow-elevation-lg z-10 bg-surface-elevated border border-border-subtle animate-scale-in origin-top">
    <ul
      tabindex="-1"
      role="listbox"
      class="py-1 overflow-auto text-base leading-6 rounded-xl max-h-60 focus:outline-none sm:text-sm sm:leading-5">
      <app-custom-dropdown-sede-item
        [location]="location"
        *ngFor="let location of locations"
        [logo]="businessesLogo"
        [business]="businessesName"
        [selectedLocation]="selectedLocation"
        (click)="selectLocation(location)">
      </app-custom-dropdown-sede-item>
    </ul>
  </div>
</div>
